import { DEFAULT_TAB_CONFIG } from "../../../../../../stores/use-space-store";
import { DefaultActiveElements } from "../../../settings/features/spaces/defaults";

const DEFAULT_DATA = {
  config: {
    showTabs: false,
    type: "spaces",
    columns: 3,
    pagination: "infinite",
    cardBorderRadius: 3,
    activeElements: DefaultActiveElements,
    alignment: "center",
    tabs: {
      t38kX5BODZ: { ...DEFAULT_TAB_CONFIG },
    },
  },
  tabs: [
    {
      id: "t38kX5BODZ",
      name: "",
      position: 0,
    },
  ],
};

export const SPACE_TEMPLATES = [
  {
    id: crypto.randomUUID(),
    ...DEFAULT_DATA,
    config: {
      ...DEFAULT_DATA.config,
      variant: "card",
    },
  },
  {
    id: crypto.randomUUID(),
    ...DEFAULT_DATA,
    config: {
      ...DEFAULT_DATA.config,
      variant: "list",
    },
  },
];

export const buildTemplate = (variant, borderRadius) => ({
  ...DEFAULT_DATA,
  config: {
    ...DEFAULT_DATA.config,
    variant,
    cardBorderRadius: borderRadius,
  },
});
